export type Falsy = false | 0 | '' | null | undefined;

export type DefinitelyTruthy<T> = false extends T
  ? never
  : 0 extends T
    ? never
    : '' extends T
      ? never
      : null extends T
        ? never
        : undefined extends T
          ? never
          : T;

export const isNotNullish = <T>(value: T): value is NonNullable<T> =>
  value !== undefined && value !== null;

export const isTruthy = <T>(x: T | Falsy): x is DefinitelyTruthy<T> => Boolean(x);

export type MaybePromise<T> = T | Promise<T>;
